module.exports = __webpack_public_path__ + "static/assets/logo-login-screen.ec182ef2.png";